import { EventEmitter, Watchdog } from '@timing71/common';
import { v4 } from 'uuid';

const WS_URL = 'wss://6fs6zsshgjaclku7vnpqi5u3cq.appsync-realtime-api.us-east-1.amazonaws.com/graphql';

const AUTH_HEADER = 'eyJob3N0IjoiNmZzNnpzc2hnamFjbGt1N3ZucHFpNXUzY3EuYXBwc3luYy1hcGkudXMtZWFzdC0xLmFtYXpvbmF3cy5jb20iLCJ4LWFtei1kYXRlIjoiMjAyNDA2MjNUMTcxMTExWiIsIngtYXBpLWtleSI6ImRhMi11ZXNubnpuc21iaDV6ZXJwYjc0cXU2dXFyZSJ9';

const PAYLOAD_HEADER = 'e30=';

const atob = function(string) {
  // Taken from https://github.com/MaxArt2501/base64-js/blob/master/base64.js
  /*
    Copyright (c) 2014 MaxArt2501

    Permission is hereby granted, free of charge, to any person obtaining a copy
    of this software and associated documentation files (the "Software"), to
    deal in the Software without restriction, including without limitation the
    rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
    sell copies of the Software, and to permit persons to whom the Software is
    furnished to do so, subject to the following conditions:

    The above copyright notice and this permission notice shall be included in
    all copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
    FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
    IN THE SOFTWARE.
  */
  const b64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
      // Regular expression to check formal correctness of base64 encoded strings
      b64re = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/;
  // atob can work with strings with whitespaces, even inside the encoded part,
  // but only \t, \n, \f, \r and ' ', which can be stripped.
  string = String(string).replace(/[\t\n\f\r ]+/g, "");
  if (!b64re.test(string))
      throw new TypeError("Failed to execute 'atob': The string to be decoded is not correctly encoded.");

  // Adding the padding if missing, for semplicity
  string += "==".slice(2 - (string.length & 3));
  var bitmap, result = "", r1, r2, i = 0;
  for (; i < string.length;) {
      bitmap = b64.indexOf(string.charAt(i++)) << 18 | b64.indexOf(string.charAt(i++)) << 12
              | (r1 = b64.indexOf(string.charAt(i++))) << 6 | (r2 = b64.indexOf(string.charAt(i++)));

      result += r1 === 64 ? String.fromCharCode(bitmap >> 16 & 255)
              : r2 === 64 ? String.fromCharCode(bitmap >> 16 & 255, bitmap >> 8 & 255)
              : String.fromCharCode(bitmap >> 16 & 255, bitmap >> 8 & 255, bitmap & 255);
  }
  return result;
};

export class GTPTelemetry extends EventEmitter {

  constructor(connectionService) {
    super();
    this._connectionService = connectionService;
    this._handleMessage = this._handleMessage.bind(this);
    this._handleTelemetry = this._handleTelemetry.bind(this);
    this.restart = this.restart.bind(this);
    this.open = false;
    this._watchdog = new Watchdog();
    this._watchdog.on('timeout', this.restart);
  }

  start() {
    this._ws = this._connectionService.createWebsocket(
      `${WS_URL}?header=${AUTH_HEADER}&payload=${PAYLOAD_HEADER}`,
      {
        autoReconnect: false,
        protocols: 'graphql-ws'
      }
    );

    this._ws.on('open', () => {
      this.open = true;
      try {
        this._ws.send('{"type":"connection_init"}');
      }
      catch {
        this.restart();
      }
    });

    this._ws.on('message', (msg) => {
      let myMsg = msg;

      if (typeof(msg.buffer) !== 'undefined') {
        myMsg = { data: msg.toString() };
      }

      this._handleMessage(JSON.parse(myMsg.data));

    });

    this._ws.on('close', () => {
      this.open = false;
    })
  }

  _handleMessage(data) {
    switch(data.type) {
      case 'connection_ack':
      case 'start_ack':
        break;
      case 'ka':
        const subMsg = this._makeSubscribeMessage();
        this._ws.send(subMsg);
        break;
      case 'data':
        this._handleTelemetry(data.payload.data.subscribe.data);
        break;
      default:
        console.log("Unhandled message", JSON.stringify(data));
    }
  }

  _makeSubscribeMessage() {
    const message = {
      "id": v4(),
      "payload": {
        "data": "{\"query\":\"subscription Subscribe($name: String!) {\\n subscribe(name: $name) {\\n __typename\\n data\\n }\\n }\",\"variables\":{\"name\":\"telemetry\"}}",
        "extensions": {
          "authorization": {
            "host": "6fs6zsshgjaclku7vnpqi5u3cq.appsync-api.us-east-1.amazonaws.com",
            "x-api-key":"da2-uesnnznsmbh5zerpb74qu6uqre"
            }
        }
      },
      "type": "start"
    };

    return JSON.stringify(message);
  }

  _handleTelemetry(raw) {
    const data = JSON.parse(atob(raw));
    // console.log(JSON.stringify(data));
    this.emit('telemetry', data);
  }

  stop() {
    this._ws.close();
  }

  restart() {
    this.stop();
    this.start();
  }

}
